import { useNavigate, useParams } from "react-router-dom";

import type {
  SelectOption,
} from "@/framework/forms/FormSelect";

import OrderCreateForm from "./OrderCreateForm";

import { buttonLink } from "@/styles/buttons";
import { OrderUserService } from "../service/orderUserService";
import { OrderCreate } from "@/api";
import { useAppBasePath } from "@/router/useAppBasePath";

export default function OrderCreate() {
 const navigate = useNavigate();
  const { direct } = useParams();
  const isDirect = direct === "true";   // not "direct"


  function handleCancel() {
    const navPath = isDirect ? "/home" : "/home/orders";
    console.log("CANCEL NAV PATH:", navPath);
    navigate(navPath);
  }
  
  
  const basePath = useAppBasePath();

async function handleSubmit(
  form: OrderCreate,
) {
  try {
    console.log("Create order:", form);
    console.log(
      "🚀 CREATE ORDER PAYLOAD:",
      JSON.stringify(form, null, 2)
    );
    const createdOrder =
      await OrderUserService.create(form);

    console.log(
      "Order created successfully:",
      createdOrder,
    );

    const navPath = basePath ==="/admin" ? "/admin" : `${basePath}/orders`;
    navigate(navPath);
  } catch (error) {
    console.error(
      "Failed to create order",
      error,
    );
  }
}


  return (
    <div 
      className="mx-auto w-full max-w-7xl px-4 py-6 lg:px-6"
    >

      <div className="mb-2 bg-blue-900"
        // style={{ backgroundImage: "url('/assets/images/servicepagebg.jpg')" }}
        >
        <div className="flex items-center justify-between rounded-t-lg bg-cover bg-center px-4 py-4 text-white">
          <h1>Create Order</h1>
          <button
            className={buttonLink}
            onClick={handleCancel}
          >
            Back
          </button>
        </div>
      </div>

      <OrderCreateForm
        onSubmit={
          handleSubmit
        }
        onCancel={
          handleCancel
        }
      />
    </div>
  );
}